import { useAppearance, assetUrl } from "@/lib/appearance";

export const LogoMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#B7F52A" />
    <circle cx="32" cy="34" r="17" fill="none" stroke="#05070D" strokeWidth="4" />
    <path d="M15 34h34M32 17c-6 5-6 29 0 34M32 17c6 5 6 29 0 34" fill="none" stroke="#05070D" strokeWidth="3" />
    <path d="M40 9l4 6 6-2-3 6 4 4h-6l-2 6-2-6h-6l4-4-3-6 6 2z" fill="#05070D" transform="translate(4 -4) scale(.75)" />
  </svg>
);

// Logo choisi dans Admin → Apparence (sinon le logo Ma Petite Ligue).
export function ScopedMark({ scope, size = 32 }) {
  const a = useAppearance(scope);
  if (!a.logo_url) return <LogoMark size={size} />;
  return <img src={assetUrl(a.logo_url)} alt="" style={{ height: a.logo_height || size }} className="w-auto object-contain" data-testid={`${scope}-custom-logo`} />;
}

export function BrandWord({ scope, accentClass }) {
  const a = useAppearance(scope);
  if (a.brand_name) return <>{a.brand_name}</>;
  return <>Ma Petite <span className={accentClass}>Ligue</span></>;
}

export const Logo = ({ size = 32, compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="app-logo">
    <ScopedMark scope="game" size={size} />
    {!compact && (
      <span className="mpl-logo-word whitespace-nowrap font-display text-[14px] font-extrabold uppercase italic leading-none tracking-wide text-white sm:text-xl">
        <BrandWord scope="game" accentClass="text-[#B7F52A]" />
      </span>
    )}
  </span>
);
